import { createAsyncThunk } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import { result } from 'lodash-es';
import { postStatuses } from '../../components/projectPost/Post';
import { INVITE_ALL_USERS } from '../../constants/post';
import { notInProgressCategoryStatus } from '../publishedPosts/PublishedPostsThunks';

const COLLECTION_NAME = 'posts';

const getCollection = () => firebase.firestore().collection(COLLECTION_NAME);

export const fetchNewInvitationsPostCount = createAsyncThunk(
    'fetchNotificationsInvitationsPost',
    async ({ email, uid }, { rejectWithValue }) => {
        try {
            const initialQuery = () => {
                if (!email) {
                    return null;
                }
                let query = getCollection();
                let invitationsQuery = query
                    .where('isDeleted', '==', false)
                    .where('isApprovedByAdmin', '==', true);
                let pendingsQuery = query.where('isReviewedByAdmin', '==', false);
                let publishedQuery = query
                    .where('isApprovedByAdmin', '==', true)
                    .where('isDeleted', '==', false)
                    .where('publisherUid', '==', uid);
                return {
                    newInvitationsNotifications: invitationsQuery,
                    newPendingsNotifications: pendingsQuery,
                    newPublishedNotifications: publishedQuery,
                };
            };

            let personalInvitationsPostIds = [];
            let publicInvitationsPostIds = [];
            let pendingPostIds = [];
            let publishedPostIds = [];

            let invitationsResultList = new Map();
            if (initialQuery()?.newInvitationsNotifications) {
                await initialQuery()
                    .newInvitationsNotifications.orderBy('createdTimestamp', 'desc')
                    .get()
                    .then(data => {
                        data.docs
                            .filter(doc => doc.data().publisherUid !== uid)
                            .filter(doc => doc.data().status !== postStatuses.done)
                            .map((doc, index) => invitationsResultList.set(index, doc.data()));

                        personalInvitationsPostIds = [...invitationsResultList.values()]
                            .filter(
                                item =>
                                    item.assignTo === null &&
                                    !!item.inviteColleagues.filter(
                                        inviteUser => inviteUser?.email === email
                                    ).length
                            )
                            .slice(0, 15)
                            .filter(
                                item =>
                                    !item.viewed.filter(viewedUser => viewedUser.email === email)
                                        .length
                            )
                            .map(item => item.uid);

                        publicInvitationsPostIds = [...invitationsResultList.values()]
                            .filter(
                                item =>
                                    item.assignTo === null &&
                                    item.inviteColleagues.includes(INVITE_ALL_USERS)
                            )
                            .slice(0, 15)
                            .filter(
                                item =>
                                    !item.viewed.filter(viewedUser => viewedUser.email === email)
                                        .length
                            )
                            .map(item => item.uid);
                    });
            }

            if (initialQuery()?.newPendingsNotifications) {
                await initialQuery()
                    .newPendingsNotifications.get()
                    .then(data => {
                        pendingPostIds = data.docs.map(doc => doc.id).slice(0, 15);
                    });
            }

            let publishedResultList = new Map();
            if (initialQuery()?.newPublishedNotifications) {
                await initialQuery()
                    .newPublishedNotifications.orderBy('createdTimestamp', 'desc')
                    .get()
                    .then(data => {
                        data.docs.map((doc, index) => publishedResultList.set(index, doc.data()));
                        publishedPostIds = [...publishedResultList.values()]
                            .filter(item => notInProgressCategoryStatus.includes(item?.status))
                            .slice(0, 15)
                            .filter(item => item.hasUpdates)
                            .map(item => item.uid);
                    });
            }

            return {
                invitationsPostIds: [...personalInvitationsPostIds, ...publicInvitationsPostIds],
                personalInvitationsPostIds: personalInvitationsPostIds,
                publicInvitationsPostIds: publicInvitationsPostIds,
                pendingPostIds: pendingPostIds,
                publishedPostIds: publishedPostIds,
            };
        } catch (e) {
            return rejectWithValue(e.message);
        }
    }
);
